import React from 'react';

type Props = {
  width?: string,
  height?: string,
  stroke?: string,
  className?: string,
};

const Photo = ({
  width,
  height,
  stroke,
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
  >
    <g>
      <g
        fill="none"
        stroke={stroke}
        strokeDasharray="none"
        strokeOpacity="1"
      >
        <path
          fillOpacity="1"
          fillRule="nonzero"
          strokeMiterlimit="4"
          strokeWidth="0.462"
          d="M7.26 6.155c-.4 0-.36.852-.906.852-.547 0-.844-2.18-1.524-2.18s-1.137 3.09-1.137 3.09h5.344S7.66 6.155 7.26 6.155m1.05-.449a.66.66 0 10.001-1.32.66.66 0 000 1.32"
          opacity="1"
          stopOpacity="1"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeMiterlimit="10"
          strokeWidth="0.401"
          d="M10.515 3.377a.802.802 0 00-.802-.801H2.987a.802.802 0 00-.802.801v5.946c0 .442.359.801.802.801h6.726a.802.802 0 00.802-.801z"
          opacity="1"
          stopOpacity="1"
        />
      </g>
    </g>
  </svg>
);

Photo.defaultProps = {
  stroke: '#000',
  width: '48',
  height: '48',
  className: null,
};

export default Photo;
